import {createContext, Dispatch} from 'react'
import {AllActions} from './state/actions'
import {IncidentsWidgetState} from './types/incidents-widget-state'
import {DEFAULT_INCIDENTS_WIDGET_STATE} from './types/default-incidents-widget-state'

export const IncidentsWidgetContext = createContext<{
    state: IncidentsWidgetState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_INCIDENTS_WIDGET_STATE, dispatch: undefined})
